import React from "react";
import { Chart } from "react-google-charts";
import numeral from "numeral";

export const PieChart = ({ data }) => {
  const positiveData = [["Proceed", "Amount"]];
  const negativeData = [];
  let total = 0;
  data.forEach(datum => {
    if (datum.value >= 0) {
      positiveData.push([`\n${datum.label}`, datum.value]);
    } else {
      negativeData.push({ label: datum.label, value: datum.value });
    }
    total = total + datum.value;
  });

  const options = {
    pieHole: 0.7,
    pieSliceText: "none",
    colors: ["#0F9BD7", "#5E6368", "#005AA8", "#C4C4C4"],
    legend: { position: "labeled", labeledValueText: "value" },
    pieStartAngle: 90,
    sliceVisibilityThreshold: 0,
    fontName: "Work Sans"
  };

  return (
    <div style={{ position: "relative" }}>
      <div style={{ zIndex: 1, position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}>
        {
          total &&
            <>
              <p style={{ textAlign: "center", fontFamily: "Work Sans", fontSize: "24px", color: "#005AA9" }}>Loan Proceeds</p>
              <p style={{ textAlign: "center", fontFamily: "Work Sans", fontSize: "24px" }}>{numeral(total).format("$0,0")}</p>
            </>
        }
      </div>
      <div style={{ zIndex: 0 }}>
        <Chart
          chartType="PieChart"
          data={positiveData}
          options={options}
          width="100%"
          height="600px"
          formatters={[{ type: "NumberFormat", column: 1, pattern: "#,##0", options: { prefix: "$", fractionDigits: 0 } }]}
        />
      </div>
      <div>
        {negativeData.length > 0 &&
          <>
            <p>NOTE: The following negative values were not included in the chart:</p>
            {negativeData.map(datum => <div key={`negative value - ${datum.label}`}>
              {`${datum.label}: ${numeral(datum.value).format("$0,0")}`}
            </div>)}
          </>}
      </div>
    </div>
  );
};
